import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import {
  LossState, productDescriptionDto, ProductLocation, ValidateSupervisorBadgeParams, LossDto, UpdateLossState,
} from './LossTypes'

const initialState: LossState = {
  badge: '',
  productDescription: undefined,
}

const validateSupervisorBadge = justForSideEffectWithPayload<ValidateSupervisorBadgeParams>()
const getProductDescription = justForSideEffectWithPayload<productDescriptionDto>()
const getProductLocation = justForSideEffectWithPayload<ProductLocation>()
const sendLossAdjustment = justForSideEffectWithPayload<LossDto>()

const clearState = (): LossState => initialState

const updateLossState = (state: LossState, action: PayloadAction<UpdateLossState>) => {
  const { key, value } = action.payload
  return { ...state, [key]: value }
}

const slice = createSlice({
  name: 'loss',
  initialState,
  reducers: {
    updateLossState,
    validateSupervisorBadge,
    clearState,
    getProductDescription,
    getProductLocation,
    sendLossAdjustment,
  },
})

export default slice.reducer

export const { actions } = slice
